import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUser } from "../utils/UserContext";
import { faWallet, faEye, faEyeSlash, faChartSimple} from "@fortawesome/free-solid-svg-icons";
import {formatCurrency, getCurrencySymbol, getRate} from "../utils/currencyUtils";
import { Link } from "react-router-dom"

function PortfolioCard({totalBal}) {
  const { user } = useUser();
  const [see, setSee] = useState(true);
  const [allstocking, setAllstocking] = useState([]);

  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchmyStockes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setAllstocking(data.mystocks);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);

  return (
    <div className="mycard mt-2">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="fw-semibold mb-0 text-white">Stock Portfolio</h6>
        <div className="col-md-auto">
          <a href={`/mystock`} className="btn btn-outline-light btn-sm rounded-3 fs-small">
            <FontAwesomeIcon icon={faEye} className="me-1" /> My Stocks
          </a>
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="d-flex align-items-start  flex-wrap">
            <div>
              <div className="text-secondary small mb-1 d-flex align-items-center">
                <div
                  className="balance-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
                    width: "30px",
                    height: "30px",
                    boxShadow: "0 2px 8px 0 rgba(37,99,235,0.12)",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faWallet}
                    style={{ fontSize: "15px", color: "#fff" }}
                  />
                </div>
                <span> Total Stock Balance:</span>
              </div>
              <div className="d-flex align-items-center justify-content-between" style={{gap:'20px'}}>
                <div className="fs-4 fw-bold text-white">
                  {see
                    ? `${getCurrencySymbol(user?.currency)}${formatCurrency(
                        totalBal * rate
                      )}`
                    : "******"}
                </div>
                <button
                  className="btn bg-black rounded-2 p-2 fw-semibold text-light"
                  style={{
                    fontSize: "13px",
                  }}
                  onClick={() => setSee(!see)}
                >
                  <FontAwesomeIcon
                    icon={see ? faEye : faEyeSlash}
                    className="me-1"
                    style={{
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  />
                  Hide Balance
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-8">
          <div className="row g-1 justify-content-lg-end">
            <div className="col-md-auto">
              <div className="portfolio-metric-card px-3 py-2 text-center h-100">
                <p className="text-secondary fw-semibold mb-1"><FontAwesomeIcon icon={faChartSimple} style={{fontSize:'14px'}} /> Total Investment</p>
                <h4 className="fw-bold text-white text-end mb-0">{allstocking.length}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PortfolioCard;
